<template>
	<section class="card">
		<van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
			<van-swipe-item v-for="(item, index) in data">
				<van-image
					class="swipe-img-item"
					:src="item.cover_cc || item.cover"
					@click="jump(item, index)"
				/>
			</van-swipe-item>
		</van-swipe>
	</section>
</template>

<script setup>
import { goLink } from "~/utils/common";

const props = defineProps({
	data: {
		type: Array,
		default: () => [],
	},
});

const jump = (item, index) => {
	item.dp_event_click && logEvent(item.dp_event_click);
	logEvent(`calc_banner_${index + 1}_click`);
	if (!item.jump_url) return;
	setTimeout(() => {
		goLink(item.jump_url, "calc-banner-m");
	}, 100);
};
</script>

<style lang="scss" scoped>
.card {
	width: 750px;
	height: 300px;
	.my-swipe {
		margin: -1px -1px 0;

		:deep(.van-swipe__indicators) {
			display: none;
		}

		.swipe-img-item {
			width: 750px;
			height: 300px;
		}
	}
}
</style>
